<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <div class="letr-left">
          <div class="carplate">
            <span class="fonints">计划编号</span>
            <el-input
              placeholder="请输入关键词"
              v-model="conditions.pno"
              clearable
            >
            </el-input>
          </div>
          <div class="caraddinfo">
            <span class="fonints">计划类型</span>
            <div class="select_box">
              <m-select
                :list="selectastricts"
                :value="stateName"
                @input="chanval1"
                placeholder="请选择"
              ></m-select>
            </div>
          </div>
          <div class="caraddinfo">
            <span class="fonints">作业场地</span>
            <div class="select_box">
              <m-select
                :list="selectastrict"
                v-model="selectinfo"
                placeholder="请选择"
              ></m-select>
            </div>
          </div>
          <div class="caraddinfo">
            <span class="fonints">作业垛位</span>
            <el-input
              placeholder="请输入关键词"
              v-model="conditions.hwstr"
              clearable
            >
            </el-input>
          </div>
        </div>
        <div>
          <button class="buttons" @click="getMemberlist">查询</button>
          <button class="buttons1" @click="reset">重置</button>
          <!-- <button class="buttons" @click="selectlist">发布</button> -->
        </div>
      </div>

      <div class="componentSty_content_table">
        <el-table
          :data="memberlist.list"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
          height="80%"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="pno" sortable="custom" label="计划号" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column label="计划类型" show-overflow-tooltip :render-header="renderHeader">
            <template v-slot="res">
              <span v-if="res.row.plantype == 1" style="text-align: center"
                >备货</span
              >
              <span v-if="res.row.plantype == 2" style="text-align: center"
                >提货</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="customname" label="货主" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="fleetname" label="代理" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="shipname" label="船名" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="goodsname" label="货物名称" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="destination" label="作业场地" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column prop="hwstr" label="作业垛位" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="fleetCharge" label="运费" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>

          <el-table-column prop="carCount" label="抢单车数" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="passCarCount" label="已通过车数" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column prop="unPasscarCount" label="未通过车数" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column prop="unCheckCarCount" label="待审核车数" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="row">
              <span
                style="color: #13d168; cursor: pointer;"
                @click="jumpParticulars(row, (limit = 1), (page = 1))"
                >查看详情</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="memberlist.total"
            :current-page="memberlist.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import mSelect from '@/components/mSelect';
import { antiShake } from '@/plugins/other.js';
export default {
  data() {
    return {
      listitem: [{ name: '计划管理' }, { name: '货源大厅' }],
      timeout: null,
      arrlist: {},
      memberlist: [],
      conditions: {
        page: 1,
        limit: 20,
        plantype: '',
        destination: '',
        hwstr: '',
        pno: '',
      },
      stateName: '',
      selectinfo: '',
      selectastricts: ['备货', '提货'],
      selectastrict: [],
    };
  },
  computed: {},
  components: {
    mTitle,
    mSelect,
  },
  created() {
    this.getMemberlist();
    this.getselectastrict();
  },
  methods: {
    async getMemberlist() {
      this.selectinfo == '全部'
        ? (this.conditions.destination = '港俊')
        : (this.conditions.destination = this.selectinfo);
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruck/fleetplanlist',
        'get',
        // this.conditions
        {
          plantype: this.conditions.plantype,
          destination: this.conditions.destination,
          hwstr: this.conditions.hwstr,
          pno: this.conditions.pno,
          page: this.conditions.page,
          limit: this.conditions.limit,
        }
      );
      if (data.code != 0) return console.log('获取表格数据失败');
      this.memberlist = data.data;
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        // this.getarrlist();
      });
    },
    sortchange(event) {
      if (event.order == 'ascending') {
        this.conditions.sidx = event.prop;
        this.conditions.order = 'asc';
      } else if (event.order == 'descending') {
        this.conditions.sidx = event.prop;
        this.conditions.order = 'desc';
      } else {
        this.conditions.sidx = null;
        this.conditions.order = null;
      }
      // this.getarrlist();
    },
    // 分页
    handleCurrentChange(index) {
      if (this.memberlist.totalCount < this.conditions.limit) return;
      this.conditions.page = index;
      this.getMemberlist();
    },
    // 计划类型
    chanval1(e) {
      this.stateName = e;
      switch (e) {
        case '备货':
          this.$set(this.conditions, 'plantype', 1);
          break;
        case '提货':
          this.$set(this.conditions, 'plantype', 2);
          break;
      }
    },
    // 作业场地
    async getselectastrict() {
      const { data } = await this.$http('api1', '/sys/dic/list', 'get', {
        dictionaryType: '货场',
      });
      if (data.code != 0) return;
      this.selectastrict = ['全部'];
      data.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    jumpParticulars(row, limit, page) {
      // console.log(row);
      let params = { pno: row.row.pno, limit: limit, page: page };
      sessionStorage.setItem('params', JSON.stringify(params));
      this.$router.push({
        name: 'supplydetail',
        params: { pno: row.row.pno, limit: limit, page: page },
      });
    },
    reset() {
      this.conditions.pno = '';
      this.conditions.hwstr = '';
      this.selectinfo = '';
      this.stateName = '';
      this.getMemberlist();
    },
  },
};
</script>
<style lang="scss" src="@/assets/planlobby.scss" scoped></style>
